import React from 'react'
import FieldCheckboxContainer from './FieldCheckboxContainer'
import fields from '../../constants/fields'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	checkboxContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginBottom: theme.spacing.unit
	}
})

const FieldCheckboxSet = ({ classes }) => (
	<React.Fragment>
		<Typography variant="caption">Kolumner</Typography>
		<div className={classes.checkboxContainer}>
			{ fields.map((props) => <FieldCheckboxContainer key={props.field} {...props} />)} 
		</div>
	</React.Fragment>
)

const StyledFieldCheckboxSet = withStyles(styles)(FieldCheckboxSet)

export default ({ visible, ...props }) => visible ? <StyledFieldCheckboxSet {...props} /> : null



// WEBPACK FOOTER //
// ./src/components/Export/FieldCheckboxSet.js